import React, { useState, useEffect } from 'react';
import MainPage from '../../composents/MainPage';
import resources from '../../services';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

const title = 'Balance sheets';
const headers = {
	icon: 'feather icon-bar-chart-2',
	title: title,
	description: 'track all information',
};

export default function CyclePage() {
	const [laoding, setLaoding] = useState(true),
		[limit, setLimit] = useState(5),
		[page, setPage] = useState(1),
		[data, setData] = useState({});
	const search = useLocation().search;

	const from = data?.pagingCounter;
	const to = data?.page * data?.limit;
	const total = data?.totalDocs;

	const get = async (limit_data, page_data) => {
		let search_str = '';
		const name = new URLSearchParams(search).get('s');
		if (name) {
			search_str = `&s=${name}`;
		}
		setLaoding(true);
		let response = await resources.stats
			.sheet(limit_data, page_data, search_str)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (response.status === 200) {
			console.log(response.data);
			setData(response.data);
		}
		setLaoding(false);
	};

	useEffect(() => {
		get(limit, page);
	}, []);

	const onLimitChange = async (e) => {
		setLimit(e.target.value);
		setPage(1);
		get(e.target.value, 1);
	};

	const onPageChange = async (e, item) => {
		e.preventDefault();
		setPage(item);
		get(limit, item);
	};

	return (
		<MainPage headers={headers} show_search>
			{laoding ? (
				<div class="d-flex align-items-center justify-content-center">
					<div class="spinner-grow" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
			) : (
				<>
					<div className="card table-card">
						<div className="card-header">
							<h5>details</h5>
						</div>

						<div className="card-block">
							<div className="dt-responsive table-responsive">
								<table
									id="simpletable"
									className="table mt-3 nowrap"
								>
									<thead>
										<tr className="table-inverse">
											<th>Num</th>
											<th>Year</th>
											<th>Month</th>
											<th>Week</th>
											{/* <th>Client</th> */}
											<th>Zones</th>
											<th>Meters</th>
											<th>Consumers</th>
											<th>Cards</th>
											<th>Consumption</th>
											<th>recharge</th>
										</tr>
									</thead>
									<tbody>
										{data?.docs.map((el, index) => {
											// return el.map((e) => {
											const date = el?._id;
											return (
												<tr key={index}>
													<td>{from + index}</td>
													<td>{date.year}</td>
													<td>
														{moment()
															.month(date.month)
															.format('MMMM')}
													</td>
													<td>{el.week}</td>
													{/* <td>{el._id?.client}</td> */}
													<td>{el.zones}</td>
													<td>{el.meters}</td>
													<td>{el.consumers}</td>
													<td>{el.cards}</td>
													<td>
														{el.consumptions?.toFixed(
															3
														)}
													</td>
													<td>
														{el.topUp?.toFixed(3)}
													</td>
												</tr>
											);
											// });
										})}
									</tbody>
								</table>
							</div>
							<div className="row mt-2 p-l-20 p-r-20">
								<div className="col-xs-12 col-sm-12 col-md-2">
									<select
										className="form-select form-control form-control-default fill form-select-sm"
										aria-label="Default select example"
										onChange={onLimitChange}
										value={limit}
									>
										<option value={5}>5</option>
										<option value={10}>10</option>
										<option value={20}>20</option>
										<option value={50}>50</option>
										<option value={200}>200</option>
										<option value={500}>500</option>
										<option value={1000}>1000</option>
										<option value={5000}>5000</option>
									</select>
								</div>
								<div className="col-xs-12 col-sm-12 col-md-4">
									<div
										className="dataTables_info"
										id="lang-dt_info"
										role="status"
										aria-live="polite"
									>
										Showing {isNaN(from) ? 0 : from} to{' '}
										{isNaN(to) ? 0 : to} of {total ?? 0}{' '}
										entries
									</div>
								</div>
								<div className="col-xs-12 col-sm-12 col-md-6">
									<div
										className="dataTables_paginate paging_simple_numbers"
										id="lang-dt_paginate"
									>
										<ul className="pagination">
											<li
												className={`paginate_button page-item previous
										${!data?.hasPrevPage ? 'disabled' : ''}`}
												id="lang-dt_previous"
											>
												<a
													onClick={(e) =>
														onPageChange(
															e,
															data?.prevPage
														)
													}
													href="#!"
													aria-controls="lang-dt"
													data-dt-idx="0"
													tabIndex="0"
													className="page-link"
												>
													Previous
												</a>
											</li>
											<li className="paginate_button page-item active">
												<a
													href="#!"
													aria-controls="lang-dt"
													data-dt-idx="1"
													tabIndex="0"
													className="page-link"
												>
													{page}
												</a>
											</li>
											<li
												className={`paginate_button page-item next ${
													!data?.hasNextPage
														? 'disabled'
														: ''
												}`}
												id="lang-dt_next"
											>
												<a
													onClick={(e) =>
														onPageChange(
															e,
															data?.nextPage
														)
													}
													href="#!"
													aria-controls="lang-dt"
													data-dt-idx="3"
													tabIndex="0"
													className="page-link"
												>
													Next
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</MainPage>
	);
}
